var _path, _g, _rect, _ellipse, _g2, _ellipse2, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverMembershipCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 607,
    viewBox: "0 0 427 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2166_684)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_684)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.235C0 83.6173 0 41.8087 11.583 20.9043C23.166 0 46.332 0 92.664 0H336.336C382.668 0 405.834 0 417.417 20.9043C429 41.8087 429 83.6173 429 167.235V439.765C429 523.383 429 565.191 417.417 586.096C405.834 607 382.668 607 336.336 607H120.5C74.168 607 23.166 607 11.583 586.096C0 565.191 0 523.383 0 439.765V167.235Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2166_684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.215,
    y: -55.8613,
    width: 270,
    height: 42,
    rx: 4,
    transform: "rotate(40 286.215 -55.8613)",
    fill: "#925DF8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2166_684)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -7.36887,
    x2: 96.0179,
    y2: -7.36887,
    transform: "matrix(0.997427 -0.0716847 0.0716834 0.997427 327.041 52.3789)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 14.7377
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2166_684)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2.94755,
    x2: 96.0179,
    y2: -2.94755,
    transform: "matrix(0.997427 -0.0716847 0.0716834 0.997427 329.619 66.8086)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 5.89509
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286.276,
    y: -55.1569,
    width: 269,
    height: 41,
    rx: 3.5,
    transform: "rotate(40 286.276 -55.1569)",
    stroke: "black",
    strokeOpacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.505,
    cy: 575.505,
    rx: 233.505,
    ry: 233.505,
    fill: "#C1C1C1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2166_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.005 775.081C501.953 775.081 591.083 685.951 591.083 576.003C591.083 466.056 501.953 376.925 392.005 376.925C282.058 376.925 192.927 466.056 192.927 576.003C192.927 685.951 282.058 775.081 392.005 775.081Z",
    stroke: "#7A7A7A",
    strokeWidth: 19.9577
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2166_684",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 342,
    width: 468,
    height: 468
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.505,
    cy: 575.505,
    rx: 233.505,
    ry: 233.505,
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.005 775.081C501.953 775.081 591.083 685.951 591.083 576.003C591.083 466.056 501.953 376.925 392.005 376.925C282.058 376.925 192.927 466.056 192.927 576.003C192.927 685.951 282.058 775.081 392.005 775.081Z",
    stroke: "#7A7A7A",
    strokeWidth: 19.9577
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.504 719.036C393.504 719.645 394.013 720.133 394.622 720.107C446.985 717.804 488.731 674.624 488.731 621.693C488.731 619.261 488.642 616.847 488.468 614.454L488.468 510.576C488.468 509.662 487.402 509.163 486.7 509.748L454.38 536.682C453.861 537.114 453.076 536.968 452.748 536.378L395.524 433.451C394.984 432.479 393.504 432.863 393.504 433.975L393.504 483.6C393.504 483.783 393.551 483.964 393.64 484.124L445.2 576.862C445.528 577.453 446.313 577.599 446.832 577.167L460.431 565.834C461.133 565.249 462.199 565.748 462.199 566.662L462.199 615.461L462.239 615.972C462.386 617.857 462.461 619.765 462.461 621.693C462.461 660.141 432.425 691.574 394.537 693.807C393.962 693.841 393.504 694.315 393.504 694.891L393.504 719.036Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.504 684.285C393.504 684.905 394.03 685.399 394.649 685.348C422.464 683.096 444.336 659.809 444.336 631.413C444.336 617.903 439.369 605.525 431.182 596.049C431.133 595.992 431.09 595.931 431.054 595.866L395.524 531.961C394.984 530.989 393.504 531.373 393.504 532.485L393.504 582.109C393.504 582.292 393.551 582.473 393.64 582.633L409.56 611.266C409.601 611.341 409.652 611.41 409.71 611.473L410.688 612.533C415.279 617.506 418.066 624.119 418.066 631.413C418.066 645.351 407.825 656.898 394.455 658.938C393.915 659.02 393.504 659.478 393.504 660.025L393.504 684.285Z",
    fill: "#7A7A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.986 658.938C386.526 659.02 386.937 659.478 386.937 660.025L386.937 684.285C386.937 684.905 386.411 685.398 385.793 685.348C357.977 683.096 336.106 659.809 336.106 631.413C336.106 617.902 341.073 605.525 349.26 596.048C349.309 595.992 349.352 595.931 349.388 595.866L384.917 531.961C385.458 530.99 386.937 531.373 386.937 532.485L386.937 582.11C386.937 582.293 386.89 582.473 386.801 582.633L370.882 611.266C370.841 611.341 370.79 611.41 370.732 611.473L369.754 612.533C365.163 617.506 362.375 624.119 362.375 631.413C362.375 645.351 372.617 656.898 385.986 658.938Z",
    fill: "#7A7A7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M386.937 483.6C386.937 483.783 386.89 483.964 386.801 484.124L335.159 577.012C334.83 577.602 334.046 577.749 333.527 577.316L319.748 565.834C319.046 565.249 317.98 565.748 317.98 566.662L317.98 621.693C317.98 660.141 348.016 691.574 385.904 693.807C386.48 693.841 386.937 694.315 386.937 694.891L386.937 719.036C386.937 719.645 386.428 720.133 385.82 720.107C333.457 717.804 291.711 674.624 291.711 621.693L291.711 510.576C291.711 509.662 292.777 509.163 293.479 509.748L325.979 536.831C326.498 537.264 327.282 537.118 327.611 536.527L384.917 433.451C385.458 432.479 386.937 432.863 386.937 433.975L386.937 483.6Z",
    fill: "#7A7A7A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2166_684)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2166_684)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 166.972,
    y1: 651.311,
    x2: 617.397,
    y2: 391.258,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 79.8308
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2166_684)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 224.658,
    y1: 736.256,
    x2: 675.083,
    y2: 476.203,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 31.9323
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_2166_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.504 719.036C393.504 719.645 394.013 720.133 394.622 720.107C446.985 717.804 488.731 674.624 488.731 621.693C488.731 619.261 488.642 616.847 488.468 614.454L488.468 510.576C488.468 509.662 487.402 509.163 486.7 509.748L454.38 536.682C453.861 537.114 453.076 536.968 452.748 536.378L395.524 433.451C394.984 432.479 393.504 432.863 393.504 433.975L393.504 483.6C393.504 483.783 393.551 483.964 393.64 484.124L445.2 576.862C445.528 577.453 446.313 577.599 446.832 577.167L460.431 565.834C461.133 565.249 462.199 565.748 462.199 566.662L462.199 615.461L462.239 615.972C462.386 617.857 462.461 619.765 462.461 621.693C462.461 660.141 432.425 691.574 394.537 693.807C393.962 693.841 393.504 694.315 393.504 694.891L393.504 719.036Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.504 684.285C393.504 684.905 394.03 685.399 394.649 685.348C422.464 683.096 444.336 659.809 444.336 631.413C444.336 617.903 439.369 605.525 431.182 596.049C431.133 595.992 431.09 595.931 431.054 595.866L395.524 531.961C394.984 530.989 393.504 531.373 393.504 532.485L393.504 582.109C393.504 582.292 393.551 582.473 393.64 582.633L409.56 611.266C409.601 611.341 409.652 611.41 409.71 611.473L410.688 612.533C415.279 617.506 418.066 624.119 418.066 631.413C418.066 645.351 407.825 656.898 394.455 658.938C393.915 659.02 393.504 659.478 393.504 660.025L393.504 684.285Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.986 658.938C386.526 659.02 386.937 659.478 386.937 660.025L386.937 684.285C386.937 684.905 386.411 685.398 385.793 685.348C357.977 683.096 336.106 659.809 336.106 631.413C336.106 617.902 341.073 605.525 349.26 596.048C349.309 595.992 349.352 595.931 349.388 595.866L384.917 531.961C385.458 530.99 386.937 531.373 386.937 532.485L386.937 582.11C386.937 582.293 386.89 582.473 386.801 582.633L370.882 611.266C370.841 611.341 370.79 611.41 370.732 611.473L369.754 612.533C365.163 617.506 362.375 624.119 362.375 631.413C362.375 645.351 372.617 656.898 385.986 658.938Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.937 483.6C386.937 483.783 386.89 483.964 386.801 484.124L335.159 577.012C334.83 577.602 334.046 577.749 333.527 577.316L319.748 565.834C319.046 565.249 317.98 565.748 317.98 566.662L317.98 621.693C317.98 660.141 348.016 691.574 385.904 693.807C386.48 693.841 386.937 694.315 386.937 694.891L386.937 719.036C386.937 719.645 386.428 720.133 385.82 720.107C333.457 717.804 291.711 674.624 291.711 621.693L291.711 510.576C291.711 509.662 292.777 509.163 293.479 509.748L325.979 536.831C326.498 537.264 327.282 537.118 327.611 536.527L384.917 433.451C385.458 432.479 386.937 432.863 386.937 433.975L386.937 483.6Z",
    fill: "#7A7A7A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2166_684",
    x: -4,
    y: -4,
    width: 435,
    height: 615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2166_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2166_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2166_684",
    x: 316.984,
    y: 21.7959,
    width: 114.828,
    height: 39.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2166_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2166_684",
    x: 319.197,
    y: 44.0459,
    width: 116.193,
    height: 32.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_2166_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2166_684",
    x: 182.949,
    y: 366.947,
    width: 418.113,
    height: 422.105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.99154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2166_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2166_684",
    x: 107.099,
    y: 316.775,
    width: 570.171,
    height: 409.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9577,
    result: "effect1_foregroundBlur_2166_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2166_684",
    x: 176.759,
    y: 422.461,
    width: 546.222,
    height: 367.538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9577,
    result: "effect1_foregroundBlur_2166_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_2166_684",
    x: 291.711,
    y: 432.895,
    width: 197.02,
    height: 291.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.98731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2166_684"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 427,
    height: 607,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2166_684"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.215,
    y: -55.8613,
    width: 270,
    height: 42,
    rx: 4,
    transform: "rotate(40 286.215 -55.8613)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMembershipCard);
export default __webpack_public_path__ + "static/media/silver-membership-card.79fc150953a10b1270699ff2800e5a0e.svg";
export { ForwardRef as ReactComponent };